(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function playActiveVideo() {
      // Busca el slide activo en la galería
      const activeMedia = document.querySelector(
        'slideshow-container [aria-current="true"] video, ' +
        '.product-media video, ' +
        'slideshow-container .is-active video'
      );
      if (activeMedia) {
        activeMedia.muted = true;
        activeMedia.play().catch(() => {});
      }
    }

    // Escucha cuando cambia la variante
    document.addEventListener('variant:changed', () => {
      setTimeout(playActiveVideo, 300);
    });

    // Escucha cuando cambia el slide activo en la galería
    document.addEventListener('slideshow:changed', () => {
      setTimeout(playActiveVideo, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
